import { ColocaKpiCard } from "@/shared/components/data-display/ColocaKpiCard";
import useTranslations from "@/shared/lang/useTranslations";
import { cn } from "@/shared/lib/utils";

import type { ItemsFilter, ItemsFilterId } from "../../constants/payoutBatches.constants";

export interface BatchItemsKpiStripProps {
  filters: readonly ItemsFilter[];
  /** Known counts per filter; a filter without one shows a dash rather than a made-up number. */
  counts: Partial<Record<ItemsFilterId, number>>;
  active: ItemsFilterId;
  onChange: (id: ItemsFilterId) => void;
}

/** The strip IS the filter: each tile narrows the rows table to what it counts. */
export function BatchItemsKpiStrip({ filters, counts, active, onChange }: BatchItemsKpiStripProps) {
  const { t } = useTranslations("payoutBatches");
  return (
    <div
      className={cn(
        "grid grid-cols-2 gap-3 sm:grid-cols-3",
        filters.length >= 6 ? "xl:grid-cols-6" : "xl:grid-cols-5",
      )}
    >
      {filters.map((filter) => (
        <ColocaKpiCard
          key={filter.id}
          label={t(filter.labelKey)}
          value={counts[filter.id] ?? "—"}
          selected={active === filter.id}
          onSelect={() => onChange(filter.id)}
        />
      ))}
    </div>
  );
}
